var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRakovarnya(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "section_channels__item-img",
    width: 116,
    height: 115,
    viewBox: "0 0 116 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_126_585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 116,
    height: 115
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.640625,
    width: 115,
    height: 115,
    rx: 57.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_126_585)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.640625,
    width: 115,
    height: 115,
    fill: "url(#paint0_linear_126_585)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9108 51.4002C43.5225 42.8318 56.0471 40.3731 58.9125 48.7566C61.7686 45.4661 67.0372 47.5273 67.6935 51.3355C72.3151 48.5625 78.9425 52.1581 79.4416 57.3806L35.7952 58.3049C34.5566 53.8866 39.4833 49.5331 43.8645 51.4002H43.9108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2024 85.1286C90.0946 87.6323 90.545 90.272 90.5334 92.9299C90.579 96.113 89.9159 99.2664 88.5922 102.162C87.2685 105.057 85.3173 107.621 82.8801 109.669L86.8639 116.888L83.3052 119.31L76.2346 115.899C78.0832 109.429 77.0018 102.099 73.2952 97.8195L68.6736 103.55L63.8395 85.563L57.6465 96.7011L50.0394 89.9258L48.4218 101.175L41.9516 98.4018L39.8441 115.576L33.0315 119.273L29.4544 116.888L33.4844 110.021C31.0143 108.038 29.027 105.52 27.6723 102.657C26.3177 99.7942 25.6312 96.6608 25.6647 93.4937C25.642 90.6282 26.1109 87.7801 27.0512 85.0732L20.6826 81.7733C20.6826 76.3383 26.3487 73.1679 33.2903 75.7837C34.6686 74.5316 36.1706 73.4229 37.7733 72.4747L31.414 66.217L32.6341 62.7508H83.8044L85.8379 65.3944L78.887 72.9461C80.2941 73.8095 81.6239 74.793 82.8616 75.8854C89.2671 73.362 94.8777 75.9409 95.5987 81.6901L89.2024 85.1286Z",
    fill: "black"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M89.2024 85.1286C90.0946 87.6323 90.545 90.272 90.5334 92.9299C90.579 96.113 89.9159 99.2664 88.5922 102.162C87.2685 105.057 85.3173 107.621 82.8801 109.669L86.8639 116.888L83.3052 119.31L76.2346 115.899C78.0832 109.429 77.0018 102.099 73.2952 97.8195L68.6736 103.55L63.8395 85.563L57.6465 96.7011L50.0394 89.9258L48.4218 101.175L41.9516 98.4018L39.8441 115.576L33.0315 119.273L29.4544 116.888L33.4844 110.021C31.0143 108.038 29.027 105.52 27.6723 102.657C26.3177 99.7942 25.6312 96.6608 25.6647 93.4937C25.642 90.6282 26.1109 87.7801 27.0512 85.0732L20.6826 81.7733C20.6826 76.3383 26.3487 73.1679 33.2903 75.7837C34.6686 74.5316 36.1706 73.4229 37.7733 72.4747L31.414 66.217L32.6341 62.7508H83.8044L85.8379 65.3944L78.887 72.9461C80.2941 73.8095 81.6239 74.793 82.8616 75.8854C89.2671 73.362 94.8777 75.9409 95.5987 81.6901L89.2024 85.1286Z;M89.2024 85.1286C90.0946 87.6323 90.545 90.272 90.5334 92.9299C90.579 96.113 89.9159 99.2664 88.5922 102.162C87.2685 105.057 85.3173 107.621 82.8801 109.669L86.8639 116.888L83.3052 119.31L76.2346 115.899C75.1996 108.821 74.9698 103.35 74.3778 98.3174L67.7311 101.17L66.3317 89.8408L58.5548 96.7297L52.3387 84.7549L47.5218 103.35L42.409 97.1064L37.7536 114.867L33.0315 119.273L29.4544 116.888L33.4844 110.021C31.0143 108.038 29.027 105.52 27.6723 102.657C26.3177 99.7942 25.6312 96.6608 25.6647 93.4937C25.642 90.6282 26.1109 87.7801 27.0512 85.0732L20.6826 81.7733C20.6826 76.3383 26.3487 73.1679 33.2903 75.7837C34.6686 74.5316 36.1706 73.4229 37.7733 72.4747L31.414 66.217L32.6341 62.7508H83.8044L85.8379 65.3944L78.887 72.9461C80.2941 73.8095 81.6239 74.793 82.8616 75.8854C89.2671 73.362 94.8777 75.9409 95.5987 81.6901L89.2024 85.1286Z;M89.2024 85.1286C90.0946 87.6323 90.545 90.272 90.5334 92.9299C90.579 96.113 89.9159 99.2664 88.5922 102.162C87.2685 105.057 85.3173 107.621 82.8801 109.669L86.8639 116.888L83.3052 119.31L76.2346 115.899C78.0832 109.429 77.0018 102.099 73.2952 97.8195L68.6736 103.55L63.8395 85.563L57.6465 96.7011L50.0394 89.9258L48.4218 101.175L41.9516 98.4018L39.8441 115.576L33.0315 119.273L29.4544 116.888L33.4844 110.021C31.0143 108.038 29.027 105.52 27.6723 102.657C26.3177 99.7942 25.6312 96.6608 25.6647 93.4937C25.642 90.6282 26.1109 87.7801 27.0512 85.0732L20.6826 81.7733C20.6826 76.3383 26.3487 73.1679 33.2903 75.7837C34.6686 74.5316 36.1706 73.4229 37.7733 72.4747L31.414 66.217L32.6341 62.7508H83.8044L85.8379 65.3944L78.887 72.9461C80.2941 73.8095 81.6239 74.793 82.8616 75.8854C89.2671 73.362 94.8777 75.9409 95.5987 81.6901L89.2024 85.1286Z",
    dur: ".8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.3675 110.705L54.282 105.621C37.5796 124.68 80.7268 126.131 63.2386 103.162L58.3675 110.705Z",
    fill: "black"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M58.3675 110.705L54.282 105.621C37.5796 124.68 80.7268 126.131 63.2386 103.162L58.3675 110.705Z;M57.9281 110.837L52.9307 103.35C35.4519 126.834 78.1385 124.93 62.1876 105.448L57.9281 110.837Z;M58.3675 110.705L54.282 105.621C37.5796 124.68 80.7268 126.131 63.2386 103.162L58.3675 110.705Z",
    dur: ".5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 12,
    r: 9,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#000000ff;#00000000",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4;12",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "53;51",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "50;-10",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 12,
    r: 9,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#000000ff;#00000000",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".4s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "2;8",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".4s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "43;35",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".4s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "50;-10",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".4s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 12,
    r: 9,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#000000ff;#00000000",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".6s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;9",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".6s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "63;75",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".6s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "50;-10",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".6s"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_585",
    x1: 87.826,
    y1: 3.98355,
    x2: 20.1239,
    y2: 102.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA031"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#FFA031;#FF5631;#FFA031;",
    dur: "1s",
    repeatCount: "indefinite"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRakovarnya);
export default __webpack_public_path__ + "static/media/rakovarnya.5d4a7bbf970629c81dd129d4dfe50900.svg";
export { ForwardRef as ReactComponent };